import React from "react";
import PropTypes from "prop-types";

class LdapLoginButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			password: "",
		};
	}

	handleChangeUsername = (event) => {
		this.setState({ username: event.target.value });
		this.props.onUsernameChange();
	};

	handleChangePassword = (event) => {
		this.setState({ password: event.target.value });
		this.props.onPasswordChange();
	};

	handleSubmit = (event) => {
		event.preventDefault();

		this.props.handleSubmit(this.state.username.toLowerCase(), this.state.password);
	};

	handleEnterPressed = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			event.stopPropagation();
			this.handleSubmit(event);
		}
	};

	render() {
		return (
			<div onKeyUp={this.handleEnterPressed}>
				<label className="form-label">Username</label>
				<input
					ref={this.props.usernameRef}
					className="form-input"
					placeholder="Enter your username"
					autoComplete="on"
					value={this.state.username}
					onChange={this.handleChangeUsername}
					id="username"
					name="username"
				/>
				<label className="form-label">Password</label>
				<input
					ref={this.props.passwordRef}
					className="form-input"
					placeholder="Enter your password"
					value={this.state.password}
					onChange={this.handleChangePassword}
					type="password"
					id="password"
					name="password"
				/>
				{this.props.loginInProgress ? (
					<button className="large login-ldap-button" disabled>
						<div>
							<i className="fa fa-refresh fa-spin fa-fw" />
						</div>
					</button>
				) : (
					<button className="large login-ldap-button" onClick={this.handleSubmit}>
						Sign In
					</button>
				)}
			</div>
		);
	}
}

LdapLoginButton.propTypes = {
	usernameRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
	passwordRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
	loginInProgress: PropTypes.bool,
	onPasswordChange: PropTypes.func,
	onUsernameChange: PropTypes.func,
	handleSubmit: PropTypes.func,
};

export default LdapLoginButton;
